import { inPlaygroundMode } from './../utils/utils';


export const togglePlaygroundModeInLocalStorage = () => {
    if(localStorage[inPlaygroundMode]){
        const val = localStorage[inPlaygroundMode] === "true" ? "false" : "true";
        localStorage[inPlaygroundMode] =  val ;
    }else{
        localStorage[inPlaygroundMode] = "true";
    }
}

export const toggleModeInLocalStorage = () => {
    if(localStorage["dark-mode"]){
        const val = localStorage["dark-mode"] === "true" ? "false" : "true";
        localStorage["dark-mode"] =  val ;
    }else{
        localStorage["dark-mode"] = "true";
    }
}